// @ts-nocheck

/**
 * * `PENDING` - Pending
 * `GENERATING` - Generating
 * `COMPLETE` - Complete
 * `ERROR` - Error
 */
export type ImageStatusEnum =
  typeof ImageStatusEnum[keyof typeof ImageStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageStatusEnum = {
  PENDING: "PENDING",
  GENERATING: "GENERATING",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
} as const;
